export const DISCOUNT_CHANGE = "discount_change";
export const COUNTDOWN_TIME_CHANGE = "countdown_change";
export const COUNTDOWN_TIME_FINISHED = "countdown_finished";
export const CLEAR_HEADER = "clear_header";
